import { http } from '@api/client';
import { PaginatedResponse } from '@api/shared';
import { paramterize, pickResponse } from '@api/utils';

export function personSearch({
  searchKey = 'name',
  query = '',
  page = 1,
  pageSize: page_size = 150,
}: PersonSearchParams) {
  return http
    .get<PaginatedResponse<PersonDetail>>('/people/searches', {
      params: paramterize({
        page,
        page_size,
        [searchKey]: query.trim(),
        disable_sort: searchKey === 'name' ? 'true' : 'false',
      }),
    })
    .pipe(pickResponse());
}

export function getC2P({
  searchKey = 'name',
  query = '',
  page = 1,
  pageSize: page_size = 150,
}: PersonSearchParams) {
  return http
    .get<PaginatedResponse<PersonDetail>>('/people/searches', {
      params: paramterize({
        page,
        page_size,
        [searchKey]: query.trim(),
        disable_sort: searchKey === 'name' ? 'true' : 'false',
      }),
    })
    .pipe(pickResponse());
}

export interface PersonMappingFilterParams {
  filters?: Array<{ id: string; value: Record<string, any> }>;
  pageSize?: number;
  page?: number;
  sortBy?: Array<{ id: string; desc: boolean }>;
}


export type FilterResponse = PaginatedResponse<PersonDetail>;

/**
 * Filter deals using dynamic operators.
 * @param option Query options
 */
 export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: PersonMappingFilterParams = {}) {
  const isBuyersSort = (key: string) => ['buyers'].includes(key);
  const isSellersSort = (key: string) => ['sellers'].includes(key);
  const isContentSort = (key: string) => ['contents'].includes(key);

  const sort_buyers = sortBy
    .filter(({ id }) => isBuyersSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_sellers = sortBy
    .filter(({ id }) => isSellersSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_contents = sortBy
    .filter(({ id }) => isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort = sortBy
    // .filter(({ id }) => !isBuyersSort(id) && !isSellersSort(id) && !isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');
  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const resolveId = (id: string) => {
    return {
      buyers: 'buyer',
      sellers: 'seller',
      contents: 'content',
      has_markets_responsible: 'markets_responsible',
    }[id] || id;
  };
  const filtersMap: Record<string, string> = {};
  newFilters.forEach(f => {
    const key = resolveId(f.id);
    const encoded = Object.entries(f.value)
      .map(([op, v]) =>
        op === '$bw' ? `$gte|||${v[0]};$lte|||${v[1]}` : `${op}|||${v.trim()}`
      )
      .join(';');
    filtersMap[key] = filtersMap[key] ? `${filtersMap[key]};${encoded}` : encoded;
  });

  const params = paramterize({
    page_size,
    page,
    sort,
    // sort_buyers,
    // sort_sellers,
    // sort_contents,
    ...filtersMap,
  });

  return http
    .get<FilterResponse>('/company-person-relation/searches', { params })
    .pipe(pickResponse());
}

interface PersonSearchParams {
  searchKey?: 'vtr_id' | 'name';
  query?: string;
  page?: number | string;
  pageSize?: number | string;
}
interface PersonDetail {
  gender: number;
  imdb_id: string;
  name: string;
  person_tmdb_id: number;
  popularity: number;
  profile_path: string;
  projects_count: number;
  role_id: string;
  vtr_id: string;
  count: number | null;
  modified_at: string | null;
}
export interface PersonPageDetails {
  gender: number;
  imdb_id: string;
  person_name: string;
  designation: string;
  deal_role: string;
  ingestion_method: string;
  currently_working: string;
  source: string;
  modified_at: string | null;
  person_tmdb_id: number;
  popularity: number;
  profile_path: string;
  projects_count: number;
  role_id: string;
  vtr_id: string;
  count: number | null;
  deal_count: number;
  content_count: number;
  companies_associated: [];
  updated_by: string;
  is_email_verified: boolean;
  email: string;
}
